<template>
  <div class="setting-advanced-chat-invite">
   <div class="module-item-style">
     <div class="module-item-title invite-title">
       <div>
         自动邀请设置
       </div>
       <div class="chat-invite-switch-btn">
         <el-switch
             v-model="invite_auto"
             @change="saveChange('invite_auto',invite_auto)"
             active-color="#68B974">
         </el-switch>
       </div>
     </div>
     <div class="module-item-tips">访客访问你的网站时，系统可以自动向其发出会话邀请</div>
     <div class="chat-invite-content-contaienr" v-if="showContentBox">
       <el-input
           class="input-textarea"
           type="textarea"
           resize="none"
           rows="4"
           @blur="saveChange('invite_document',invite_document)"
           placeholder="请输入内容..."
           v-model="invite_document">
       </el-input>
       <div class="module-item-title invite-title" style="padding-top: 15px;">
         <div>
           网站邀请设置
         </div>
         <div class="chat-invite-switch-btn">
           <el-switch
               v-model="is_open_invite"
               @change="saveChange('is_open_invite',is_open_invite)"
               active-color="#68B974">
           </el-switch>
         </div>
       </div>
       <div style="padding: 0 45px;box-sizing: border-box;" v-if="is_open_invite">
         <div style="padding-top: 15px;font-size: 12px;color: #666;padding-bottom: 10px;">
           <span class="" style="padding-right: 15px;">自动邀请类型</span>
           <el-radio-group v-model="invite_page_type" @change="saveChange('invite_page_type',invite_page_type)">
             <el-radio class="" label="1" v-if="false">时间</el-radio>
             <el-radio class="" label="0">页面</el-radio>
           </el-radio-group>
         </div>
         <div class="chat-invite-time-set" style="padding-bottom: 10px;" v-if="invite_page_type == 0">
           邀请会话在访客访问网站 <input min="0" class="chat-invite-num" v-model="invite_page_num" @change="saveChange('invite_page_num',invite_page_num)" type="number">个页面，在页面停留<input min="0" class="chat-invite-num" v-model="invite_time" @change="saveChange('invite_time',invite_time)" type="number"> 秒后发出
         </div>
         <div class="chat-invite-time-set" v-if="invite_page_type == 1">
           邀请会话在访客访问商城 <input min="0" class="chat-invite-num" v-model="invite_page_time" @change="saveChange('invite_page_time',invite_page_time)" type="number"> 分钟后发出
         </div>
       </div>
       <div class="chat-invite-time-set" v-if="!is_open_invite">
         邀请会话在访客访问页面停留 <input min="0" class="chat-invite-num" v-model="invite_time" @change="saveChange('invite_time',invite_time)" type="number"> 秒后发出
       </div>
       <div class="refuse-container">
         <div class="refuse-title">当访客拒绝该邀请后</div>
         <el-radio-group v-model="invite_refuse" class="refuse-radio" @change="saveChange('invite_refuse',invite_refuse)">
           <el-radio class="refuse-radio-item" label="0">本次访问不再自动邀请</el-radio>
           <el-radio class="refuse-radio-item" :label="invite_refuse > 0 ? invite_refuse : '1'">
             间隔 <input min="0" class="chat-invite-num" v-model="invite_refuse" @change="saveChange('invite_refuse',invite_refuse)" type="number"> 秒再次发出对话邀请
           </el-radio>
         </el-radio-group>
       </div>
     </div>
   </div>
  </div>
</template>

<script>
  export default {
    name: 'setting-advanced-chat-invite',
    data() {
      return {
        showContentBox:true,
        invite_auto:false,
        invite_time:'0',
        Initinvite_time:'0',
        invite_refuse:'',
        invite_document:'',
        invite_page_num: '1',
        invite_page_time: '1',
        invite_page_type: '1',
        is_open_invite:true
      }
    },
    created() {
      this.getInviteData()
    },
    mounted() {

    },
    methods: {
      getInviteData(){
        this.$http.getInviteConfigAPI().then( res => {
          if(res.status == 1){
            let data = res.data
            if(data.invite_auto == 1){
              this.invite_auto = true
              this.showContentBox = true
            }else {
              this.invite_auto = false
              this.showContentBox = false
            }
            if (data.is_open_invite == 1){
              this.is_open_invite = true
            } else {
              this.is_open_invite = false
            }
            this.invite_document = data.invite_document
            this.invite_time = data.invite_time
            this.Initinvite_time = data.invite_refuse
            this.invite_refuse = data.invite_refuse
            this.invite_page_num = data.invite_page_num
            this.invite_page_type = data.invite_page_type
            this.invite_page_time = data.invite_page_time
          }
        })
      },
      saveChange(name,value){
        console.log('name====', name)
        console.log('value====', value)
        let postValue ;
        if(name == 'invite_refuse' && value == ''){
          this.$message({
            message: '保存失败',
            type: 'error',
          })
          return
        }
        if(name == 'invite_time' && value == ''){
          this.$message({
            message: '保存失败',
            type: 'error',
          })
          return
        }
        if(value === ''){
          postValue = ''
        }else {
          if(value === 'true' || value === true){
            postValue = 1
          }else if (value === 'false' || value === false) {
            postValue = 0
          }else {
            postValue = value
          }
        }
        this.$http.saveConfigAPI({
          name,
          value:postValue
        }).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getInviteData()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-advanced-chat-invite {
    .invite-title {
      display: flex;

      .chat-invite-switch-btn {
        margin-left: auto;
      }
    }
    .chat-invite-content-contaienr{
      .input-textarea {
        width: 600px;
      }
      .chat-invite-time-set{
        color: #666;
        padding: 10px 0 20px;
        font-size: 12px;
      }
      .chat-invite-num{
        width:60px;
        height:40px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(238,238,238,1);
        border-radius:4px;
        outline: none;
        padding: 5px;
        text-align: center;
        margin: 0 5px;
      }
      .refuse-title{
        color: #333;
        font-size: 12px;
        padding-bottom: 17px;
      }
      .refuse-radio{
        .refuse-radio-item{
          display: block;
          line-height: 40px;
          color: #333;
          white-space: inherit;
          .el-radio__label{
            font-size: 12px;
            font-weight: normal;
          }
          .refuse-item-detail{
            color: #999;
          }
        }
      }
    }
  }
</style>
